import pluralize from "pluralize";

export const CountCell = ({ count, label }) =>
  _.isNil(count) || count === 0 ? `No ${pluralize.plural(label)}` : pluralize(label, count, true);
